import React, { useEffect, useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, IconButton, Grid, TextField, FormControl, Paper, Tooltip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FaInfoCircle } from "react-icons/fa";
import { useClipboard } from 'use-clipboard-copy';
import { FaCopy } from "react-icons/fa";
import CatalogService from '../../services/CatalogService';
const USERPI : string = process.env.REACT_APP_PI_USER || ''; 
const PWPI : string = process.env.REACT_APP_PI_PW || ''; 

interface ExpansiblePanelProps {
  title: string;
  content: string;
}

interface ExpansiblePanelPIProps {
  title: string;
  nombres: string;
  apellidos: string;
  usuario: string;
}

export const ExpansiblePanel: React.FC<ExpansiblePanelProps> = ({ title, content }) => {
  const [expanded, setExpanded] = useState(false);

  const handlePanelChange = () => {
    setExpanded(!expanded);
  };

  return (
    <Accordion expanded={expanded} onChange={handlePanelChange}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-content"
        id="panel-header"
      >
        <Typography><FaInfoCircle/>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>{content}</Typography>
      </AccordionDetails>
    </Accordion>
  );
};

const catalogService = new CatalogService();

export const ExpansiblePanelPI: React.FC<ExpansiblePanelPIProps> = ({ title,nombres,apellidos,usuario }) => {
  const [expanded, setExpanded] = useState(false);
  const [listPros, setListPros] = useState(catalogService.getUsuariosProPBI);
  let [cuentaPro,setCuentaPro] = useState(true);
  const clipboardUser = useClipboard({
    copiedTimeout: 2000, // timeout duration in milliseconds
  });
  const clipboardPass = useClipboard({
    copiedTimeout: 2000, // timeout duration in milliseconds
  });

  const handlePanelChange = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    const correo = usuario+"@espol.edu.ec";
    if (listPros.includes(correo)) {
      setCuentaPro(true)
    } else {
      setCuentaPro(false)
    }
  }, []);

  return (
    <Accordion expanded={expanded} onChange={handlePanelChange}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-content"
        id="panel-header"
      >
        <Typography><FaInfoCircle/> {title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {cuentaPro ?
        <Paper elevation={3} style={{ padding: 16 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                ¡Hola {nombres} {apellidos}!
              </Typography>
              <Typography variant="body1" paragraph>
                Usted posee una cuenta Pro de Power BI, puedes continuar y acceder a todas las funciones del Dashboard con tu cuenta de ESPOL.
              </Typography>
            </Grid>
            {/* <Grid container justifyContent="space-between" alignItems="flex-start" m={1}>
              <Grid item>
                <Button variant="contained" color="primary" onClick={handlePanelChange}>
                  Si Poseo
                </Button>
              </Grid>
              <Grid item>
                <Button variant="contained" color="secondary" onClick={() => {setCuentaPro(false)}}>
                  No Poseo
                </Button>
              </Grid>
            </Grid> */}
          </Grid>
        </Paper>
        :
        <Paper elevation={3} style={{ padding: 16 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
               ¡Hola {nombres} {apellidos}!
            </Typography>
            <Typography variant="body1" paragraph>
                Usted <strong>NO</strong> posee una cuenta Pro de Power BI.
            </Typography>
            <Typography variant="body1" paragraph>
            Usted debe <strong>cerrar sesión</strong> en la cuenta que ya tenga iniciada para que no haya inconvenientes y utilizar las credenciales facilitadas a continuación:
            </Typography>
          </Grid>
          <Grid item xs={5}>
            <FormControl fullWidth>
              <TextField
                id="text1"
                inputRef={clipboardUser.target}
                label="Usuario"
                variant="outlined"
                fullWidth
                size='small'
                value={USERPI}
              />
            </FormControl>
          </Grid>
          <Grid item xs={1}>
            <Tooltip title={clipboardUser.copied ? 'Copiado' : 'Copiar al Portapapeles'} arrow>
              <IconButton className="btn1" onClick={clipboardUser.copy}>
                  <FaCopy />
              </IconButton>
            </Tooltip>  
          </Grid>
          <Grid item xs={5}>
            <FormControl fullWidth>
              <TextField
                id="text2"
                type='password'
                inputRef={clipboardPass.target}
                label="Contraseña"
                variant="outlined"
                fullWidth
                size='small'
                value={PWPI}
              />
            </FormControl>
          </Grid>
          <Grid item xs={1}>
            <Tooltip title={clipboardPass.copied ? 'Copiado' : 'Copiar al Portapapeles'} arrow>
              <IconButton className="btn2" onClick={clipboardPass.copy}>
                  <FaCopy />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        {/* <Typography variant="body1" paragraph>
         Tiene las siguientes opciones para acceder con facilidad a su dashboard:
        </Typography>
        <List>
          <ListItem>
            <Typography variant="body1">
              1. Cerrar su cuenta y acceder con el usuario facilitado en la parte superior.
            </Typography>
          </ListItem>
          <ListItem>
            <Typography variant="body1">
              2. Acceder en otro navegador con la información facilitada en la parte superior.
            </Typography>
          </ListItem>
        </List> */}
        </Paper> 
         }
      </AccordionDetails>
    </Accordion>
  );
};